(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ViewPendingSharedExpensesController', ViewPendingSharedExpensesController);

    ViewPendingSharedExpensesController.$inject = ['$uibModalInstance', 'pendingSharedExpenses', 'TravelExpenseService', 'toastr'];

    function ViewPendingSharedExpensesController($uibModalInstance, pendingSharedExpenses, TravelExpenseService, toastr) {
        var vm = this;
        vm.pendingSharedExpenses  = pendingSharedExpenses;
        vm.cancel                 = cancel;
        vm.approveShareExpense    = approveShareExpense;
        vm.disapproveShareExpense = disapproveShareExpense;

        function activate() {

        }

        function cancel() {
            $uibModalInstance.close();
        }

        function approveShareExpense(share) {
            TravelExpenseService.approveShareExpense(share).then(function(response){
                vm.pendingSharedExpenses = response.data;
                if(vm.pendingSharedExpenses.length === 0){
                    toastr.success('Successfully saved!');
                    vm.cancel();
                }
            });
        }

        function disapproveShareExpense(share) {
            TravelExpenseService.disapproveShareExpense(share).then(function(response){
                vm.pendingSharedExpenses = response.data;
                if(vm.pendingSharedExpenses.length === 0){
                    toastr.success('Successfully saved!');
                    vm.cancel();
                }
            });
        }
        activate();
    }

})();